import { ResourceClass } from "@/apis/rc"
import { ActionLogClass, AdClass,ConfigClass,MenuClass,NewsClass,NewsTypeClass,RoleClass,UserClass } from "@/apis/ucenter"
import { ChangePswArgs, CreateAdArgs, CreateConfigArgs, CreateMenuArgs, CreateNewsArgs, CreateNewsTypeArgs, CreateResourceBase64Args, CreateRoleArgs, CreateUserArgs, QueryActionLogArgs, QueryAdArgs, QueryMenuArgs, QueryNewsArgs, QueryNewsTypeArgs, QueryResourceArgs, QueryRoleArgs, QueryUserArgs, SetRoleMenuArgs, SetUserRoleArgs, UpdateUserSelfArgs } from "@/models/args"
import { ActionLogDto, AdDto, ConfigDto, MenuDto, NewsDto, NewsTypeDto, ResourceDto, RoleDto, UserDto } from "@/models/dtos"
import { OptionsType, ProvinceCityType } from "@/models/types"
import { defineStore } from "pinia"

// ucenter
const actionLogApi = new ActionLogClass()
const adApi = new AdClass()
const configApi = new ConfigClass()
const menuApi = new MenuClass()
const newsApi = new NewsClass()
const newsTypeApi = new NewsTypeClass()
const roleApi = new RoleClass()
const userApi = new UserClass()
// rc
const resourceApi = new ResourceClass()
export const useDataStore = defineStore('data',{
  state: () => {
    return {
      // ucenter
      actionLogTotal: 0,
      adTotal: 0,
      menuTotal: 0,
      newsTotal: 0,
      newsTypeTotal: 0,
      roleTotal: 0,
      userTotal: 0,

      // rc
      resourceTotal: 0,

      areaOptions: <ProvinceCityType[]>[],
      roleOptions: <OptionsType[]>[],
      newsTypeOptions: <OptionsType[]>[],
      adSlotOptions: <OptionsType[]>[],
      linkTypeOptions: <OptionsType[]>[],
      isOptions: [{label: '是', value: 1},{label: '否', value: 0}],
      isBoolOptions: [{label: '是', value: true},{label: '否', value: false}]
    }
  },
  getters: {},
  actions: {
    //#region ucenter
    getActionLogList(args: QueryActionLogArgs){
      return new Promise<ActionLogDto[]>((resolve, reject) => {
        actionLogApi.gets(args).then((resp) => {

          this.$patch({
            actionLogTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getAdList(args: QueryAdArgs){
      return new Promise<AdDto[]>((resolve, reject) => {
        adApi.gets(args).then((resp) => {

          this.$patch({
            adTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    createAd(args: CreateAdArgs){
      return new Promise<number>((resolve, reject) => {
        adApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    updateAd(args: CreateAdArgs){
      return new Promise<number>((resolve, reject) => {
        adApi.update(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    deleteAd(id: number){
      return new Promise<number>((resolve, reject) => {
        adApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    stateAd(id: number,status: number){
      return new Promise<number>((resolve, reject) => {
        adApi.state(id, status).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    rankAd(id: number,rank: number){
      return new Promise<number>((resolve, reject) => {
        adApi.rank(id, rank).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getConfigList(){
      return new Promise<ConfigDto[]>((resolve, reject) => {
        configApi.gets().then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    createConfig(args: CreateConfigArgs){
      return new Promise<number>((resolve, reject) => {
        configApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    updateConfig(args: CreateConfigArgs[]){
      return new Promise<number>((resolve, reject) => {
        configApi.update(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getMenuList(args: QueryMenuArgs){
      return new Promise<MenuDto[]>((resolve, reject) => {
        menuApi.gets(args).then((resp) => {

          this.$patch({
            menuTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    createMenu(args: CreateMenuArgs){
      return new Promise<number>((resolve, reject) => {
        menuApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    updateMenu(args: CreateMenuArgs){
      return new Promise<number>((resolve, reject) => {
        menuApi.update(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    sortMenu(id: number, sort: number){
      return new Promise<number>((resolve, reject) => {
        menuApi.sort(id, sort).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getNewsList(args: QueryNewsArgs){
      return new Promise<NewsDto[]>((resolve, reject) => {
        newsApi.gets(args).then((resp) => {

          this.$patch({
            newsTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    createNews(args: CreateNewsArgs){
      return new Promise<number>((resolve, reject) => {
        newsApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    updateNews(args: CreateNewsArgs){
      return new Promise<number>((resolve, reject) => {
        newsApi.update(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    deleteNews(id: number){
      return new Promise<number>((resolve, reject) => {
        newsApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    stateNews(id: number,status: number){
      return new Promise<number>((resolve, reject) => {
        newsApi.state(id, status).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    topNews(id: number,status: number){
      return new Promise<number>((resolve, reject) => {
        newsApi.top(id, status).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    homeNews(id: number,status: boolean){
      return new Promise<number>((resolve, reject) => {
        newsApi.home(id, status).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getNewsTypeList(args: QueryNewsTypeArgs){
      return new Promise<NewsTypeDto[]>((resolve, reject) => {
        newsTypeApi.gets(args).then((resp) => {

          const options = resp.data.map(x => {
            return {
              label: x.name,
              value: x.id
            }
          })
          
          this.$patch({
            newsTypeTotal: resp.total,
            newsTypeOptions: options
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    createNewsType(args: CreateNewsTypeArgs){
      return new Promise<number>((resolve, reject) => {
        newsTypeApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    updateNewsType(args: CreateNewsTypeArgs){
      return new Promise<number>((resolve, reject) => {
        newsTypeApi.update(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    deleteNewsType(id: number){
      return new Promise<number>((resolve, reject) => {
        newsTypeApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getRoleList(args: QueryRoleArgs){
      return new Promise<RoleDto[]>((resolve, reject) => {
        roleApi.gets(args).then((resp) => {

          this.$patch({
            roleTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    createRole(args: CreateRoleArgs){
      return new Promise<number>((resolve, reject) => {
        roleApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    updateRole(args: CreateRoleArgs){
      return new Promise<number>((resolve, reject) => {
        roleApi.update(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    deleteRole(id: number){
      return new Promise<number>((resolve, reject) => {
        roleApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    allRole(){
      return new Promise<RoleDto[]>((resolve, reject) => {
        roleApi.all().then((resp) => {
          const roles = resp.map(x => {
            return {
              label: x.name,
              value: x.id
            }
          })
          this.$patch({
            roleOptions: roles
          })

          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    setMenus(id: number, menuIdList: SetRoleMenuArgs){
      return new Promise<number>((resolve, reject) => {
        roleApi.setMenus(id, menuIdList).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getUserList(args: QueryUserArgs){
      return new Promise<UserDto[]>((resolve, reject) => {
        userApi.gets(args).then((resp) => {

          this.$patch({
            userTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    exportUser(args: QueryUserArgs){
      return new Promise((resolve, reject) => {
        userApi.excel(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    authUser(id: string, state: boolean){
      return new Promise<number>((resolve, reject) => {
        userApi.auth(id,state).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    createUser(args: CreateUserArgs){
      return new Promise<number>((resolve, reject) => {
        userApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    updateUser(args: UpdateUserSelfArgs){
      return new Promise<number>((resolve, reject) => {
        userApi.update(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    deleteUser(id: string){
      return new Promise<number>((resolve, reject) => {
        userApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    setRoles(data: SetUserRoleArgs){
      return new Promise<number>((resolve, reject) => {
        userApi.setRoles(data).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
  
    setPsw(data: ChangePswArgs){
      return new Promise<number>((resolve, reject) => {
        userApi.setPsw(data).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
  
    setAllow(id: string, state: number){
      return new Promise<number>((resolve, reject) => {
        userApi.setAllow(id, state).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion


    //#region rc
    getResourceList(args: QueryResourceArgs){
      return new Promise<ResourceDto[]>((resolve, reject) => {
        resourceApi.gets(args).then((resp) => {
          this.$patch({
            resourceTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createResource(args: FormData){
      return new Promise<ResourceDto>((resolve, reject) => {
        resourceApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createResourceBase64(args: CreateResourceBase64Args){
      return new Promise<ResourceDto>((resolve, reject) => {
        resourceApi.createBase64(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    deleteResource(id: number){
      return new Promise<number>((resolve, reject) => {
        resourceApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    deleteResourceFile(id: number, projectNo: string){
      return new Promise<number>((resolve, reject) => {
        resourceApi.removeFile(id,projectNo).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion

    //#region shop
    //#endregion
  }
})